import React from 'react';
const Back = () => (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M11 14L5 8L11 2", stroke: "#7D8085", "stroke-width": "1.5", "stroke-linejoin": "round" })));
export default Back;
